import { resultPathFromBanId } from "./resultUrl";

export const DEFAULT_WIDGET_TITLE = "Vérifiez gratuitement le contexte d’une adresse";
export const WIDGET_ORIGIN = "https://etatdulieu.com";
export const ACCENT_PRESETS = {
  blue: "#2563eb",
  green: "#15803d",
  purple: "#7c3aed",
  orange: "#c2410c",
};

const cleanText = (value, max) =>
  String(value || "").replace(/[\u0000-\u001f\u007f]/g, " ").replace(/\s+/g, " ").trim().slice(0, max);

export function sanitizeWidgetConfig(input = {}) {
  const partner = /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(input.partner || "")
    ? input.partner
    : "etatdulieu-partenaire";
  const theme = ["light", "dark", "auto"].includes(input.theme) ? input.theme : "light";
  const rawAccent = String(input.accent || "blue").toLowerCase();
  const accent = ACCENT_PRESETS[rawAccent]
    ? rawAccent
    : /^#[0-9a-f]{6}$/.test(rawAccent) ? rawAccent : "blue";
  return {
    partner,
    city: cleanText(input.city, 80),
    theme,
    accent,
    title: cleanText(input.title, 100) || DEFAULT_WIDGET_TITLE,
    locale: input.locale === "fr" ? "fr" : "fr",
  };
}

export function widgetSearchParams(config) {
  const safe = sanitizeWidgetConfig(config);
  const params = new URLSearchParams();
  Object.entries(safe).forEach(([key, value]) => {
    if (value && !(key === "title" && value === DEFAULT_WIDGET_TITLE)) params.set(key, value);
  });
  return params;
}

export function widgetReportUrl(banId, config, origin = WIDGET_ORIGIN) {
  const safe = sanitizeWidgetConfig(config);
  const url = new URL(resultPathFromBanId(banId), origin);
  url.searchParams.set("partner", safe.partner);
  url.searchParams.set("utm_source", safe.partner);
  url.searchParams.set("utm_medium", "widget");
  url.searchParams.set("utm_campaign", "address_check");
  return url.toString();
}

export function accentColor(accent) {
  return ACCENT_PRESETS[accent] || (/^#[0-9a-f]{6}$/i.test(accent || "") ? accent : ACCENT_PRESETS.blue);
}

